module.exports = __webpack_public_path__ + "static/media/delivery1.d860ee1a.png";